export const BusyStatus = {
  AVAILABLE: 'available',
  BUSY: 'busy',
  PARTIALLY_BUSY: 'partially_busy',
  OFF: 'off'
} as const

export type BusyStatusType = typeof BusyStatus[keyof typeof BusyStatus]
